import React from 'react';
import PropTypes from 'prop-types';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

const Banner = ({ title, description, actions, children, className = '' }) => {
  return (
    <div
      className={`relative overflow-hidden rounded-xl border border-blue-200 bg-gradient-to-r from-blue-50 via-indigo-50 to-cyan-50 p-4 sm:p-5 ${className}`}
      role="status"
    >
      <div className="pointer-events-none absolute inset-0 opacity-40">
        <div className="absolute -right-8 -top-8 h-28 w-28 rounded-full bg-blue-200 blur-2xl" />
        <div className="absolute -bottom-8 left-6 h-24 w-24 rounded-full bg-cyan-200 blur-2xl" />
      </div>

      <div className="relative flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3">
          <span className="mt-0.5 inline-flex h-8 w-8 items-center justify-center rounded-lg bg-white/80 text-blue-600 shadow-sm ring-1 ring-blue-100">
            <InformationCircleIcon className="h-5 w-5" />
          </span>
          <div>
            <p className="text-sm font-semibold text-slate-900">{title}</p>
            {description && <p className="mt-1 text-sm text-slate-600">{description}</p>}
            {children && <div className="mt-3 text-sm text-slate-700">{children}</div>}
          </div>
        </div>

        {actions && <div className="relative z-10 flex flex-wrap items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
};

Banner.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  actions: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string
};

export default Banner;
